
import { State } from "@/store/State";
import { defineComponent } from "vue";
import { mapState,mapGetters,mapActions } from "vuex";

export default defineComponent({
  name:'Player',
  computed:{
    ...mapGetters(['isPlaying']),
    ...mapState({
      currentSong: function (this,state:State){
        return state.currentSong
      },
      sound: function (this,state:State){
        return state.sound
      },
      seek: function (this,state:State){
        return state.seek
      },
      duration: function (this,state:State){
        return state.duration
      },
      progress: function (this,state:State){
        return state.progress
      }
    }) 
  },
  methods:{
    ...mapActions(['togglePlay','updateSeek'])
  }
})
//['currentSong','sound']
